var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 4C0.5 2.11438 0.5 1.17157 1.08579 0.585786C1.67157 0 2.61438 0 4.5 0H5.5C6.48142 0 6.97214 0 7.39443 0.211146C7.81672 0.422291 8.11115 0.814861 8.7 1.6L10.5 4H17.3C18.4201 4 18.9802 4 19.408 4.21799C19.7843 4.40973 20.0903 4.71569 20.282 5.09202C20.5 5.51984 20.5 6.0799 20.5 7.2V14.8C20.5 15.9201 20.5 16.4802 20.282 16.908C20.0903 17.2843 19.7843 17.5903 19.408 17.782C18.9802 18 18.4201 18 17.3 18H3.7C2.5799 18 2.01984 18 1.59202 17.782C1.21569 17.5903 0.909734 17.2843 0.717987 16.908C0.5 16.4802 0.5 15.9201 0.5 14.8V4ZM9.79289 8.29289L6.79289 11.2929L8.20711 12.7071L9.5 11.4142V15H11.5V11.4142L12.7929 12.7071L14.2071 11.2929L11.2071 8.29289L10.5 7.58579L9.79289 8.29289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.17470234db61c5be0dfd3a82be73680c.svg";
export { ForwardRef as ReactComponent };